import * as React from "react";
import { connect } from "react-redux";
import PatientsProfile from "../../screens/Patients/PatientsProfile";

import {
  PatientUser,
  PatientUserSlectedPage,
  PatientsInActive,
  PatientsDetailsview,
  PatientPrescriptionview,
  itempageSelected
} from "./action";
class PatientsProfileContainer extends React.Component<Props, State> {
  render() {
    return (
      <PatientsProfile
        PatientUser={this.props.PatientUser}
        patientuserDtlsList={this.props.patientuserDtlsList}
        patientuserDtlsCount={this.props.patientuserDtlsCount}
        PatientUserSlectedPage={this.props.PatientUserSlectedPage}
        PatientsInActive={this.props.PatientsInActive}
        PatientsDetailsview={this.props.PatientsDetailsview}
        patientsmainDtls={this.props.patientsmainDtls}
        PatientPrescriptionview={this.props.PatientPrescriptionview}
        patientsprscrptnls={this.props.patientsprscrptnls}
        patientsprscrptnlsCount={this.props.patientsprscrptnlsCount}
        itempageSelected={this.props.itempageSelected}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    PatientUser: (value) => {
      dispatch(PatientUser(value));
    },
    PatientUserSlectedPage: value => {
      dispatch(PatientUserSlectedPage(value));
    },
    PatientsInActive: value => {
      dispatch(PatientsInActive(value));
    },
    PatientsDetailsview: value => {
      dispatch(PatientsDetailsview(value));
    },
    PatientPrescriptionview: value => {
      dispatch(PatientPrescriptionview(value));
    },
    itempageSelected: value => {
      dispatch(itempageSelected(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    patientuserDtlsList: state.PatientsReducer.patientuserDtlsList,
    patientuserDtlsCount: state.PatientsReducer.patientuserDtlsCount,
    patientsmainDtls: state.PatientsReducer.patientsmainDtls,
    patientsprscrptnls: state.PatientsReducer.patientsprscrptnls,
    patientsprscrptnlsCount: state.PatientsReducer.patientsprscrptnlsCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(PatientsProfileContainer);
